var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4715,187.218c0-3.149-1.642-5.785-4.5-6.482v-.7a1.5,1.5,0,1,0-3,0v.7c-2.869.7-4.5,3.323-4.5,6.482v5.128l-2,2.051v1.026h16V194.4l-2-2.051Zm-6,11.282a1.688,1.688,0,0,0,.4-.041,2.042,2.042,0,0,0,1.441-1.21,2.112,2.112,0,0,0,.149-.8h-4A2.041,2.041,0,0,0,4709,198.5Z",
    transform: "translate(-4701 -178.5)",
    fill: "#eff1f3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.b1eb975c503a021dbe24450c6e240388.svg";
export { ForwardRef as ReactComponent };